<template>
  <div class="shop-finally" v-if="currentPagePayment.type">
    <div class="shop-finally__img" :style="{
        background: `url(${ currentDesing.image}) no-repeat center / cover`,
      }">
    </div>
    <div class="shop-finally__wrap">
      <h1 class="shop-finally__kind">
        {{currentPagePayment.type === "certificate" ? "СЕРТИФИКАТ" : "АБОНЕМЕНТ"}}
      </h1>

      <div class="shop-form__block">
        № {{currentPagePayment.type === "certificate" ? currentPagePayment.certificate_number : currentPagePayment.abonement_number }}
      </div>
      <div class="shop-form__block">{{ currentPagePayment.Data.Name }}</div>
      <div class="shop-form__block">
        {{ (currentPagePayment.Amount.split(".")[0] / 100).toLocaleString() }} ₽
      </div>

      <div class="shop-form__block">
        {{ titleStr }}
      </div>

      <div class="shop-form__block">
        <p>{{expirationStr}}.</p>
        <p>
          Для использования {{currentPagePayment.type === "certificate" ? "сертификата" : "абонемента"}} нужен номер, который на нем указан (или
          указан в сообщении).
        </p>
        <p>
          {{currentPagePayment.type === "certificate" ? "Сертификат" : "Абонемент"}} распространяется на все услуги и товары представленные в
          студии (в том числе абонементы).
        </p>
        <p>
          {{currentPagePayment.type === "certificate" ? "Сертификат" : "Абонемент"}} можно использовать как полностью, так и частично в течении
          нескольких посещений.
        </p>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import getExpirationStringForCertificate from "@/functions/getExpirationStringForCertificate";
import getExpirationStringForAbonement from "@/functions/getExpirationStringForAbonement";

const store = useStore();

const route = useRoute();

const currentPagePayment = computed(() => store.state.currentPagePayment);

const currentDesing = computed(() => store.state.allDesignTypes.find(i => i.id === currentPagePayment.value.design_id))

const expirationStr = computed(() => {
  if (currentPagePayment.value.type === "certificate") {
    return getExpirationStringForCertificate(currentPagePayment.value.currentLoyality)
  } else {
    return getExpirationStringForAbonement(currentPagePayment.value.currentLoyality)
  }
})

const parseLoyalityName = computed(() => {
  if (currentPagePayment.value.type === "certificate") {
    const cells: {
      first: "Номинал" | string | null;
      second: number | string | null;
    } = {
      first: null,
      second: null,
    };
    const title = currentPagePayment.value.currentLoyality.title;

    const isNominal = title.split("/")[0].trim() === "Номинал";

    if (isNominal) {
      cells.first = "Номинал";
      cells.second = currentPagePayment.value.currentLoyality.balance + ' ₽';
    }

    return cells;
  } else {
    return "";
  }
});

const titleStr = computed(() => {
  return currentPagePayment.value.currentLoyality.title.replace(/\//g, '|');
})
</script>

<style lang="scss" scoped>
.shop-finally {
  max-width: 1270px;
  display: flex;
  align-items: center;
  gap: 40px;

  &__img {
    min-width: calc(50% - 40px);
    background: #a09c95;
    border-radius: 24px;
    height: 626px;
    img {
      width: 100px;
      height: auto;
      object-fit: cover;
    }
  }

  .shop-form__block {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }

  &__row {
    display: flex;
    gap: 10px;
    width: 100%;

    .shop-form__block {
      flex-grow: 1;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;

    &__img {
      width: 100%;
    }

    &__wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .shop-form__block {
      width: 100%;
      text-align: center;
    }

    &__row {
      justify-content: space-between;
      gap: 10px;

      .shop-form__block {
      }
    }
  }
}
</style>
